module.exports = __webpack_public_path__ + "img/myket.6c07648.png";